import { useCallback } from 'react'
import { LocalStorage } from '../../packages/storage/localStorage'
import { paths } from '../../routes/paths'
import { ErrorType } from '../../types/error'
import { logging } from '../../utils/logging'

export const useApiErrorHandler = () => {
  const logout = useCallback(async () => {
    const backofficeNode = await LocalStorage.getItem('budget-flow-store')

    await LocalStorage.setItem('budget-flow-store', backofficeNode.delete('authToken'))

    window.location.replace(paths.login)
  }, [])

  return useCallback(
    async (e: ErrorType) => {
      logging.error(`Error type: ${e.type}, Error message: ${e.error.message}`)

      switch (e.type) {
        case 'ApiResponseError': {
          logging.error(e.error.message)

          if ([401, 403].includes(e.error.response.status)) {
            await logout()
          }

          break
        }

        case 'AuthenticationError': {
          await logout()

          break
        }

        case 'ApiFetchError': {
          logging.error(e.error.message)

          break
        }

        default: {
          break
        }
      }
    },
    [logout]
  )
}
